<template>
  <el-backtop
    class="gs-backtop"
    :class="{ 'is-narrow': isNarrow }"
    :visibility-height="320"
    :bottom="isNarrow ? 72 : 56"
    :right="isNarrow ? 16 : 40"
  >
    <div class="gs-backtop-btn" :class="{ 'is-narrow': isNarrow }" aria-label="回到顶部" title="回到顶部">
      <svg class="gs-backtop-icon" viewBox="0 0 24 24" aria-hidden="true">
        <path
          d="M6.2 14.3a1 1 0 0 0 1.4 1.4L12 11.3l4.4 4.4a1 1 0 0 0 1.4-1.4l-5.1-5.1a1 1 0 0 0-1.4 0l-5.1 5.1Z"
          fill="currentColor"
        />
      </svg>
    </div>
  </el-backtop>
</template>

<script>
export default {
  name: 'BackUP',
  data() {
    return {
      isNarrow: typeof window !== 'undefined' && window.innerWidth < 960
    }
  },
  mounted() {
    window.addEventListener('resize', this.syncNarrow)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.syncNarrow)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.syncNarrow)
  },
  methods: {
    syncNarrow() {
      this.isNarrow = window.innerWidth < 960
    }
  }
}
</script>

<style scoped>
.gs-backtop-btn {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  min-width: 56px;
  min-height: 56px;
  max-width: 56px;
  max-height: 56px;
  aspect-ratio: 1 / 1;
  padding: 0;
  margin: 0;
  border: 1px solid rgba(1, 101, 255, 0.18);
  border-radius: 14px;
  background: linear-gradient(180deg, #ffffff 0%, #f3f7ff 100%);
  color: #0165ff;
  box-shadow: 0 8px 20px rgba(22, 50, 92, 0.12);
  cursor: pointer;
  overflow: hidden;
  flex-shrink: 0;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease, color 0.18s ease;
}
.gs-backtop-btn:hover {
  transform: translateY(-1px);
  border-color: rgba(1, 101, 255, 0.36);
  color: #0052d6;
  box-shadow: 0 10px 24px rgba(1, 101, 255, 0.18);
}
.gs-backtop-btn:active {
  transform: translateY(0);
}
.gs-backtop-icon {
  width: 24px;
  height: 24px;
  display: block;
  flex: 0 0 auto;
}
:deep(.el-backtop.gs-backtop),
::v-deep .el-backtop.gs-backtop {
  width: 56px !important;
  height: 56px !important;
  min-width: 56px !important;
  min-height: 56px !important;
  max-width: 56px !important;
  max-height: 56px !important;
  padding: 0 !important;
  line-height: 0 !important;
  border-radius: 14px !important;
  background: transparent !important;
  box-shadow: none !important;
  overflow: hidden !important;
}
:deep(.el-backtop.gs-backtop > *),
::v-deep .el-backtop.gs-backtop > * {
  display: block !important;
  width: 56px !important;
  height: 56px !important;
  margin: 0 !important;
}
:deep(.el-backtop.gs-backtop.is-narrow),
::v-deep .el-backtop.gs-backtop.is-narrow {
  width: 44px !important;
  height: 44px !important;
  min-width: 44px !important;
  min-height: 44px !important;
}
:deep(.el-backtop.gs-backtop.is-narrow > *),
::v-deep .el-backtop.gs-backtop.is-narrow > * {
  width: 44px;
  height: 44px;
}
.gs-backtop-btn.is-narrow {
  width: 44px;
  height: 44px;
  min-width: 44px;
  min-height: 44px;
  max-width: 44px;
  max-height: 44px;
  border-radius: 12px;
}
.gs-backtop-btn.is-narrow .gs-backtop-icon {
  width: 20px;
  height: 20px;
}
</style>
